module.exports = __webpack_public_path__ + "img/appointed_member.48e35650.png";